// user state
import axios from "axios";
import Links from "@/shared/constants/Links";
import LoginUtil from "../../../login/LoginUtil";

const state = {
    user: null,
    systemSettings: null,
    programmeTypes: [],
    currentProgrammeType: {},
    modeOfEntries: [],
    currentSession: {}, // for lecturers
    super: false,
    isHostel: false,
    isLoading: false
}

const actions = {
    async fetchCurrentUser() {
        return await axios.get("get-current-user")
    },

    async fetchProgrammeTypes(){
        return await axios.get(Links.programmeTypes.all)
    },

    logout: () => {
        LoginUtil.resetAccessToken()
        LoginUtil.resetRefreshToken()
    }
}

const getters = {
    getUser: state => state.user,
    getSuper: state => state.super,
    getCurrentSession: state => state.currentSession,
    getProgrammeTypes: state => state.programmeTypes,
    getCurrentProgrammeType: state => state.currentProgrammeType,
    getModeOfEntries: state => state.modeOfEntries,
    getSystemSettings: state => state.systemSettings,
    isHostel: state => state.isHostel,
    isLoading: state => state.isLoading
}

const mutations = {
    setCurrentUser: (state, data) => {
        state.user = data.user
        state.super = data.superOption
    },
    setCurrentSession: (state, data) => (state.currentSession = data),
    setProgrammeType: (state, data) => (state.programmeTypes = data),
    setCurrentProgrammeType: (state, data) => (state.currentProgrammeType = data),
    setModeOfEntries: (state, data) => (state.modeOfEntries = data),
    setHostel: (state, data) => (state.isHostel = data),
    setLoading: (state, data) => (state.isLoading = data),
}

export default {
    state,
    actions,
    getters,
    mutations
}
